import PropTypes from 'prop-types'
import { InputDropdown } from '@artprov/design-system'
import { useDropdownBlur } from '@/common/utils/hooks/useDropdownBlur.js'
import { getDropdownValue } from '@/common/utils/dropdownUtils.js'

const FormDropdown = ({ label, placeholder = 'Seleccionar', value, options, onSelect, onBlur, disabled = false }) => {
  const { containerRef } = useDropdownBlur(onBlur)

  const displayValue = value || undefined

  const handleChange = (event) => {
    const raw = getDropdownValue(event)
    if (raw === undefined || raw === null) return
    if (raw === '') {
      onSelect({ value: '', label: '' })
      return
    }
    const selected = options.find((opt) => opt.label === raw)
    if (selected) onSelect(selected)
  }

  return (
    <div ref={containerRef} className="relative">
      <InputDropdown
        label={label}
        value={displayValue}
        placeholder={placeholder}
        onChange={handleChange}
        isDisabled={disabled}
        fullWidth
        defaultSelection={true}
      >
        <InputDropdown.Option key="empty" value="">
          {placeholder}
        </InputDropdown.Option>
        {options.map((option) => (
          <InputDropdown.Option key={option.value} value={option.label}>
            {option.label}
          </InputDropdown.Option>
        ))}
      </InputDropdown>
    </div>
  )
}

FormDropdown.propTypes = {
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  onSelect: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
}

export default FormDropdown
